import React, { createContext, useContext, useEffect } from "react";
import useCampaign from "../hooks/campaign";
import { useLocation } from "react-router-dom";

export const CampaignContext = createContext();

export const useCampaignContext = () => useContext(CampaignContext);

export const CampaignProvider = ({ children }) => {
  const { campaign, campaignCode, subpage, setCampaignCode } = useCampaign({});

  return (
    <CampaignContext.Provider
      value={{ campaign, campaignCode, subpage, setCampaignCode }}
    >
      {children}
    </CampaignContext.Provider>
  );
};

export const CampaignUpdater = () => {
  const location = useLocation();
  const { setCampaignCode } = useCampaignContext();

  useEffect(() => {
    setCampaignCode(location.pathname);
  }, [location, setCampaignCode]);

  return null;
};
